function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M71.42,0h-9.65l.36,24.03s-.18,7.1-8.01,8.19l-3.09-4.37h-14.38l-3.09,4.37c-7.83-1.09-8.01-8.19-8.01-8.19l.36-24.03h-9.65C-1.94,49.52,.07,97.39,.07,97.39c0,5.83,4.55,4.92,4.55,4.92H83.07s4.55,.91,4.55-4.92c0,0,2-47.88-16.2-97.39Zm-4.4,82.9c0,2.15-1.75,3.9-3.9,3.9H24.13c-2.15,0-3.9-1.75-3.9-3.9v-25.8c0-2.15,1.75-3.9,3.9-3.9H63.12c2.15,0,3.9,1.75,3.9,3.9v25.8Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "d",
  points: "40.46 79.91 49.63 79.91 59.21 69.98 59.21 60.06 58.98 60.06 40.46 79.91"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "d",
  points: "53.5 60.06 37.44 60.06 27.51 70.33 27.51 79.91 34.98 79.91 53.5 60.06"
})));

var SvgBallastBagPlain = function SvgBallastBagPlain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87.69 102.36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBallastBagPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ballast-bag-plain.4d2bde18.svg";
export { ForwardRef as ReactComponent };